<template>
  <div>
    <h1>Activité hors-clinique</h1>
    <el-row style="width: 820px" v-loading="hcactiviteLoadStatus == 1">
      <el-col :span="24">
        <form-hcactivite :ismeddetail="ismeddetail" ref="formHcm">
        </form-hcactivite>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <div style="margin-top: 8px">
      <el-button @click="onBack">Retour</el-button>
      <el-button type="primary" @click="onSubmit">Enregistrer</el-button>
      <el-button @click="onCancel">Annuler</el-button>
    </div>
  </div>
</template>
<script>
import FormHcactivite from "@/components/rh/ui/form/FormHcactivite";
import { trimStringInObj } from "@/fonctions";

export default {
  components: { "form-hcactivite": FormHcactivite },

  data() {
    return {
      loadCount: 0,
    };
  },
  props: {
    ismeddetail: Boolean,
    routetolist: Object,
  },
  created() {
    this.$store.dispatch("hcm/loadHcactivitemedecin", this.idHcm);
  },
  mounted() {
    this.afficheData();
  },
  computed: {
    idHcm() {
      // récupère le id de l'activité HC dans l'url
      return String(this.$route.params.idhcm);
    },
    hcactiviteLoadStatus() {
      return this.$store.state.hcm.hcactivitemedecinLoadStatus;
    },
    hcactiviteUpdateStatus() {
      // 1 = action en cours, 2 = succès, 3 = échec
      return this.$store.state.hcm.hcactivitemedecinUpdateStatus;
    },
  },
  methods: {
    afficheData() {
      if (this.hcactiviteLoadStatus == 2) {
        // charge les données de l'activité HC
        const hcm = this.$store.state.hcm.hcactivitemedecin;
        // garde les données chargées dans le localStorage pour les comparée avec les modifs
        localStorage.hcmLoaded = JSON.stringify(hcm);
      } else if (this.hcactiviteLoadStatus == 3) {
        // message échec
        this.$message.error({ message: "Echec du chargement des données !" });
      }
    },
    onSubmit() {
      this.$refs.formHcm.$refs.formHcactivite.validate((valid) => {
        if (valid) {
          let hcmdata = this.$store.state.hcm.hcactivitemedecin;

          // enlever les espaces avant et après dans les string
          trimStringInObj(hcmdata);

          // vérifie si l'activité hc ne chevauche pas une même activité crée pour ce médecin
          const hcmInBD = this.$store.getters["hcm/HcactiviteInBD"];
          const id = this.idHcm;
          const doublon =
            hcmInBD.filter(
              (m) =>
                m[0] != id &&
                m[1] == hcmdata.id_med &&
                m[2] == hcmdata.id_hcactivite &&
                m[3] < hcmdata.fin_date &&
                m[4] > hcmdata.debut_date
            ).length > 0;
          // prépare les données pour les comparer avec les données avant modification et pour l'enregistrement
          const hcmdataStr = JSON.stringify(hcmdata);

          // vérifie si les données ont été modifiées
          if (localStorage.hcmLoaded == hcmdataStr) {
            this.$message({
              message: "Les données n'ont pas été modifiées",
            });
            // vérifie si une activité HC idendique existe déjà pour le médecin
          } else if (doublon) {
            this.$alert(
              "Cette activité HC chevauche une activité identique déjà existante pour ce médecin",
              "Attention",
              {
                confirmButtonText: "Fermer",
                dangerouslyUseHTMLString: true,
              }
            );
            return false;
          } else {
            // si plus d'erreur
            //maj l'enregistrement
            this.$store.dispatch("hcm/updateHcactivitemedecin", hcmdata);
          }
        } else {
          return false;
        }
      });
    },
    onCancel() {
      const hcm = this.$store.state.hcm.hcactivitemedecin;
      const hcmStr = JSON.stringify(hcm);
      if (localStorage.hcmLoaded != hcmStr) {
        // si les données ont été modifiées
        let dataObj = JSON.parse(localStorage.hcmLoaded);
        this.$store.commit("hcm/setHcactivitemedecin", dataObj);
        this.$message({
          message: "Les modifications ont été annulées",
          type: "warning",
        });
      } else {
        this.$message({
          message: "Les données n'ont pas été modifiées",
        });
      }
    },
    onBack() {
      // prépare les données pour les comparer avec les données avant modification
      const hcm = this.$store.state.hcm.hcactivitemedecin;
      const hcmStr = JSON.stringify(hcm);

      if (localStorage.hcmLoaded == hcmStr) {
        // si pas de modifications
        // retourne à la liste des formations post-graduées
        this.$router.push(this.routetolist);
      } else {
        this.$confirm(
          "Continuer sans enregistrer les modification ?",
          "Attention !",
          {
            confirmButtonText: "Continuer",
            cancelButtonText: "Annuler",
            type: "warning",
          }
        ).then(() => {
          // retourne à la liste des formations post-graduées
          this.$router.push(this.routetolist);
        });
      }
    },
  },
  watch: {
    hcactiviteLoadStatus() {
      // ne lance l'affichage des données que si toutes les données sont chargées
      // lorsqu'on charge directement la page
      this.afficheData();
    },
    hcactiviteUpdateStatus() {
      // gère les messages et la navigation après soumission du formulaire
      if (this.hcactiviteUpdateStatus == 2) {
        // message succès
        this.$message({
          message: "Les modifications ont été enregistrées.",
          type: "success",
        });
        // place les données sauvegardée dans le localStorage (nouvelles données initiales)
        const hcm = this.$store.state.hcm.hcactivitemedecin;
        localStorage.hcmLoaded = JSON.stringify(hcm);
      } else if (this.hcactiviteUpdateStatus == 3) {
        // message échec
        this.$message.error({ message: "Echec de l'enregistrement !" });
      }
    },
  },
};
</script>
